// extracted by mini-css-extract-plugin
export default {"value":"panelDropdown_value__Zc+YR","arrow":"panelDropdown_arrow__qe7cM","panelContent":"panelDropdown_panelContent__MmiYk","option":"panelDropdown_option__sgO6B"};